export const CMS_API_BASE = 'https://api.dev.auxo.dk';

export function getItemSlug(item) {
  if (!item) return '';
  if (typeof item.slug === 'string') return item.slug;
  if (typeof item.slug === 'object' && item.slug !== null) {
    return item.slug._ || Object.values(item.slug)[0] || '';
  }
  return item.id || '';
}

export function getItemImage(item) {
  if (!item) return '';
  if (Array.isArray(item.image) && item.image.length > 0) return item.image[0];
  if (typeof item.image === 'string') return item.image;
  return '';
}

export function getItemImages(item) {
  if (!item) return [];
  if (Array.isArray(item.image) && item.image.length > 0) return item.image.filter(Boolean);
  if (Array.isArray(item.images) && item.images.length > 0) return item.images.filter(Boolean);
  if (typeof item.image === 'string' && item.image) return [item.image];
  if (typeof item.images === 'string' && item.images) return [item.images];
  return [];
}

export function optimizeImageUrl(url, options = 'width=800,quality=80,format=auto') {
  if (!url || typeof url !== 'string') return '';
  if (!url.includes('assets.auxodev.dk') || url.includes('/cdn-cgi/image/')) return url;
  return url.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/${options}/`);
}

export async function fetchReferences({ limit = 50, offset = 0 } = {}) {
  try {
    const res = await fetch(`${CMS_API_BASE}/public/v2/content/references?limit=${limit}&offset=${offset}`);
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    const data = await res.json();
    return {
      items: Array.isArray(data.items) ? data.items : (Array.isArray(data) ? data : []),
      total: data.total ?? (Array.isArray(data.items) ? data.items.length : (Array.isArray(data) ? data.length : 0))
    };
  } catch (err) {
    console.error('Error fetching references from CMS:', err);
    return null;
  }
}

export async function fetchReferenceBySlug(slug) {
  if (!slug) return null;
  try {
    const res = await fetch(`${CMS_API_BASE}/public/by-slug/${encodeURIComponent(slug)}`);
    if (res.ok) {
      const data = await res.json();
      if (data && (data.title || data.id)) {
        return data;
      }
    }
  } catch (err) {
    console.warn('Direct slug fetch failed, falling back to collection search:', err);
  }

  // Fallback: search in references list
  try {
    const listRes = await fetch(`${CMS_API_BASE}/public/v2/content/references?limit=100`);
    if (listRes.ok) {
      const data = await listRes.json();
      const items = Array.isArray(data.items) ? data.items : (Array.isArray(data) ? data : []);
      const found = items.find(item => getItemSlug(item) === slug);
      if (found) return found;
    }
  } catch (err) {
    console.error('Error fetching reference list fallback:', err);
  }

  return null;
}
